import api from '@/services/api'

export default {
    namespaced: true,
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        async downloadStockReport(context, payload) {

            const response = await api.get(`/StockBalance/GetStockReport`, {
                params: payload,
                responseType: 'blob'
            })

            const blob = new Blob([response.data], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)

            const link = document.createElement('a')
            link.href = url
            link.download = `Relatorio_Estoque_${new Date()}.pdf`
            document.body.appendChild(link)
            link.click()

            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        },
        async downloadCustomerHistoryReport(context, payload) {

            const response = await api.get(`/StockBalance/GetCustomerHistoryReport`, {
                params: payload,
                responseType: 'blob'
            })

            const blob = new Blob([response.data], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)

            const link = document.createElement('a')
            link.href = url
            link.download = `Relatorio_Estoque_${new Date()}.pdf`
            document.body.appendChild(link)
            link.click()

            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        }
    }
}